import axios from "@/axios";

export const app = {
    state: () => ({
        temp: JSON.parse(localStorage.getItem("temp")) ? JSON.parse(localStorage.getItem("temp")) : {},
        lang: localStorage.getItem("lang") || "pl",
        lang_arr: JSON.parse(localStorage.getItem("lang_arr")) ? JSON.parse(localStorage.getItem("lang_arr")) : {},
        config: JSON.parse(localStorage.getItem('config')) || {},
        push: localStorage.getItem('push') || 'yes',
        application_server_public_key: localStorage.getItem('application_server_public_key') || null,
    }),
    actions: {

        async getApplicationServerPublicKey({commit}) {


            await axios
                .get('base/pushpublickkey')
                .then(response => {

                    let data = response.data.data;
                    let application_server_public_key = data.key;

                    localStorage.setItem('application_server_public_key', application_server_public_key);
                    commit('application_server_public_key', application_server_public_key);

                });
        },

        async pushSet({commit, push}) {

            localStorage.setItem('push', push);
            commit('push', push);

        },

        async init({commit, dispatch}) {

            await axios
                .get('base/init')
                .then(response => {

                    let data = response.data;


                    let config = data.config;
                    // let initial = data.initial;
                    // let modules = data.modules;
                    // let menu = data.menu;

                    localStorage.setItem('config', JSON.stringify(config));
                    commit('config', config);

                    // localStorage.setItem('initial', JSON.stringify(initial));
                    // commit('initial', initial);
                    //
                    // localStorage.setItem('modules', JSON.stringify(modules));
                    // commit('modules', modules);
                    //
                    // localStorage.setItem('menu', JSON.stringify(menu));
                    // commit('menu', menu);

                })
                .catch(error => {

                    let error_data = error.response.data;
                    let error_status = error.response.status;
                    let error_header = error.response.headers;
                    let error_code = error_data.code;

                    console.log(error_data);
                    console.log(error_status);
                    console.log(error_header);

                    switch (error_code) {
                        case 'no-login':
                        case 'token-expired':
                            dispatch('user/logout', null, {root: true})
                            break;
                    }


                });
        },

        /**
         * Aktualizowanie obiektu "temp" w localStorage
         * @param commit pozwala zmieniać zmienne w "state"
         * @param data dane do zaktualizowania
         */
        setTempToStorage({commit}, data) {

            localStorage.setItem("temp", JSON.stringify(data));

            commit("setTemp", data);
        },

        /**
         * Aktualizowanie obiektu "lang" w localStorage
         * @param commit pozwala zmieniać zmienne w "state"
         * @param lang język do zaktualizowania
         */
        setLangToStorage({commit}, lang) {

            localStorage.setItem("lang", lang);

            commit("setLang", lang);
        },

        /**
         * Pobieranie i zapisywanie do localStorage nazw systemowych w różnych językach
         * @param commit pozwala zmieniać zmienne w "state"
         */
        langArrLoad({commit}) {

            let url = "base/lang";

            let params = {
                scope: 'code,lang,text'
            };

            axios
                .get(url, {params: params})
                .then((response) => {

                    let data = response.data.data;

                    let data_transformed = {}

                    data.map(element => {
                        if (data_transformed[element.lang] === undefined)
                            data_transformed[element.lang] = {}

                        data_transformed[element.lang][element.code] = element.text
                    })

                    commit('setLangArr', data_transformed);

                    localStorage.setItem('lang_arr', JSON.stringify(data_transformed));

                })
        },
    },
    mutations: {

        setLangArr(state, data) {
            state.lang_arr = data;
        },

        setLang(state, lang) {
            state.lang = lang;
        },

        setTemp(state, data) {
            state.temp = data;
        },

        config(state, config) {
            state.config = config;
        },

        application_server_public_key(state, application_server_public_key) {
            state.application_server_public_key = application_server_public_key;
        },

        push(state, push) {
            state.push = push;
        }
    },
    getters: {
        getLangName(state) {
            if (state.lang === 'pl')
                return "Polski"
            if (state.lang === 'en')
                return "Angielski"
            if (state.lang === 'de')
                return "Niemiecki"
        }
    },
    namespaced: true
}